import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({ onSubscribe }) => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <>
      <nav data-testid="navbar">
        <Link to="/" className="nav-logo" data-testid="nav-logo">
          <img src="/nc-logo.jpg" alt="Nile Capital" />
          <span>Nile Capital</span>
        </Link>
        <div className="nav-center">
          <Link to="/about" className={isActive('/about')} data-testid="nav-about">About</Link>
          <Link to="/articles" className={isActive('/articles')} data-testid="nav-articles">Articles</Link>
          <Link to="/newsletter" className={isActive('/newsletter')} data-testid="nav-newsletter">Newsletter</Link>
          <Link to="/pricing" className={isActive('/pricing')} data-testid="nav-pricing">Pricing</Link>
        </div>
        <div className="nav-right">
          <button className="btn-dark" onClick={onSubscribe} data-testid="nav-subscribe-btn">Subscribe</button>
        </div>
        <button className="nav-hamburger" onClick={() => setMobileOpen(true)} data-testid="nav-hamburger">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </button>
      </nav>

      <div className={`nav-mobile-overlay ${mobileOpen ? 'open' : ''}`} onClick={() => setMobileOpen(false)} />
      <div className={`nav-mobile-menu ${mobileOpen ? 'open' : ''}`}>
        <button className="mobile-close" onClick={() => setMobileOpen(false)} data-testid="mobile-close">&times;</button>
        <Link to="/" onClick={() => setMobileOpen(false)} className={isActive('/')}>Home</Link>
        <Link to="/about" onClick={() => setMobileOpen(false)} className={isActive('/about')}>About</Link>
        <Link to="/articles" onClick={() => setMobileOpen(false)} className={isActive('/articles')}>Articles</Link>
        <Link to="/newsletter" onClick={() => setMobileOpen(false)} className={isActive('/newsletter')}>Newsletter</Link>
        <Link to="/pricing" onClick={() => setMobileOpen(false)} className={isActive('/pricing')}>Pricing</Link>
        <div className="mobile-actions">
          <button className="btn-dark" onClick={() => { setMobileOpen(false); onSubscribe(); }}>Subscribe</button>
        </div>
      </div>
    </>
  );
};

export default Navbar;
